// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"f0f923c8","667":"a80b9ea1","907":"79998275"}[chunkId] + ".chunk.js";
};